export default __webpack_public_path__ + "static/media/vegasbabyKlein.85e72f72.jpg";